module.exports = __webpack_public_path__ + "img/person_1_index.a253644e.png";